export default __webpack_public_path__ + "static/media/agentInfo-icon.8daf4f6e.svg";